<template>
  <div class="lockScreen">
    <div class="lockFrame">
      <div class="title" style="border: none;font-size: 32px;width: auto">{{ $store.getters['core/getAppName'] || "模具管理系统" }}</div>
      <div class="userName">{{ this.loginForm.userName }}</div>
      <div class="inputBody">
        <el-input v-model="this.loginForm.inputPassword" :placeholder="$t('password')" class="passwordInput input_item" show-password></el-input>
      </div>
      <el-button :loading="loading" @click="close" icon="el-icon-right"></el-button>
      <div style="text-align: center;font-size: 30px">
<!--        <el-button type="text" class="lockButton">{{ $t('forget') }}</el-button>-->
        <el-button @click="closeWeb" type="text" class="lockButton">{{ $t('account') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
const messages = {
  zhCn: {
    userName: '用户名',
    password: '密码',
    forget: '忘记密码',
    account: '更换帐号'
  },
  zhTw: {
    userName: '用戶名',
    password: '密碼',
    forget: '忘記密碼',
    account: '更換帳號'
  },
  en: {
    userName: 'User Name',
    password: 'Password',
    forget: 'Forget Password',
    account: 'Change Account'
  }
}

export default {
  name: "NewLockScreen",
  i18n: {messages},
  data() {
    return {
      loading: false,
      loginForm: {
        inputPassword: '',
        userName: this.$store.state.core.currentUser?.user_name,
        verifyId: this.$store.state.core.verifyCode
        /* verifyCode: '',
         verifyId: '',*/
      },
    }
  },
  methods: {
    async close() {
        this.loading = true;
      console.log("this.loginForm-=",this.loginForm)
        await this.$http('frameLoginService.login',this.loginForm).then(response => {
        // this.$axios.post('frame/login', this.loginForm).then(response => {
          this.loading = false;
          console.log("response-=",response)
          let res = response.data;
          if (res.code !== 0) {
            /*this.createCode();*/
            return this.$message.error(res.message);
          }else {
            this.$store.state.core.lock = false
          }

          localStorage.setItem('token', res.data)
          this.$router.push('desktop?v=' + new Date().getTime())
        }, error => {
          this.loading = false;
          /*this.createCode();*/
          return this.$message.error('登录失败，' + error.message);
        })
    },
    closeWeb() {
      this.$store.commit('core/LOGOUT');
      this.$router.push('/login')
    }
  },
  computed: {
    bgStyle() {
      return this.$store.getters['wallpaper/getLoginWallpaperStyle']
    }
  }
};
</script>

<style lang="less" scoped>
@bodyHeight: 50vh;
@bodyWidth: 50vh;
@userBody: 21vh;
@bodyHeightTmp: @bodyHeight ./ 2.5;
@marginTopTmp: @userBody + @bodyHeightTmp;

.lockScreen {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 999;
  background-repeat: repeat;
  backdrop-filter: blur(30px);
}

.title {
  font-size: 30px;
  color: #0184ba;
  text-align: center;

  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
  border: none;
}

.lockFrame {
  background-size: cover;
  backdrop-filter: blur(20px);
  position: absolute;
  left: 50%;
  top: 43%;
  margin-left: @bodyWidth ./ (-2);
  margin-top: @bodyHeight ./ (-2);
  height: @bodyHeight + 10;
  width: @bodyWidth + 10;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 5px;
  box-shadow: rgba(0, 0, 0, 0.7) 0 0 10px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

.userImg {
  z-index: 10;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: @userBody ./ (-2);
  margin-top: @marginTopTmp ./ (-2);
  height: @userBody;
  width: @userBody;
  border-radius: @userBody ./ 2;
  background-size: 100% 100%;
  border: #ffffff solid 1px;
}

.lockButton {
  color: black;
}

.inputBody {
  width: 100%;
  margin-top: 10px;
  text-align: center;

  .el-button {
    border-radius: 0;
  }

  .el-input__inner {
    border-radius: 0;
  }
}

.passwordInput {
  width: 26vh;
}

.userName {
  display: block;
  font-size: @bodyHeight ./10;
  text-align: center;
}

/deep/.el-input__wrapper{
  box-shadow: none;
  background-color: rgb(85 0 0 / 0);
}

.input_item{
  border-bottom: 1px black solid;
  width: 60%;
}

</style>